import React from 'react';
import styled from 'styled-components';
import LoadingIndicator from '../components/LoadingIndicator';
import { ColorTheme } from '../styling/theme';

const Container = styled.div`
  height: 60vh;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export default function LoadingPageView() {
  return (
    <Container>
      <LoadingIndicator size={40} />
    </Container>
  );
}